<p-autoComplete [inputId]="inputId" [ngModel]="selecionados" (ngModelChange)="alterar($event)" [suggestions]="sugestoes" (completeMethod)="buscar($event.query)"
  (onKeyUp)="tecla($event)" field="nome" dataKey="cnpj" [multiple]="true" [unique]="true" [autoHighlight]="true" [delay]="300" [minLength]="2"
  [showEmptyMessage]="true" emptyMessage="Nenhum cliente encontrado. Com o CPF/CNPJ completo, Enter adiciona assim mesmo." appendTo="body"
  [disabled]="disabled" placeholder="Busque pelo nome ou CPF/CNPJ do cliente" styleClass="bc-campo" panelStyleClass="bc-painel">
  <ng-template let-c pTemplate="item">
    <div class="bc-item">
      <span class="bc-nome">{{ c.nome }}</span>
      <span class="bc-sub">{{ formatar(c.cnpj) }} · {{ detalhe(c) }}</span>
    </div>
  </ng-template>
  <ng-template let-c pTemplate="selectedItem">
    <span class="bc-token" [title]="formatar(c.cnpj) + ' · ' + detalhe(c)">
      <span class="bc-token-nome" [class.bc-sem-cadastro]="!c.nome">{{ c.nome || formatar(c.cnpj) }}</span>
      <small *ngIf="c.nome">{{ formatar(c.cnpj) }}</small>
    </span>
  </ng-template>
</p-autoComplete>
<small class="bc-erro" *ngIf="erro">{{ erro }}</small>
